import { nanoid } from 'nanoid';

/**
 * Dropdown placeholder option.
 * @type {Object}
 */
export const OPTION_PLACEHOLDER_OBJECT = { Key: nanoid(), Value: '' };

export const OPTION_PLACEHOLDER_ARRAY = '';

export const LABEL_POSITIONS = {
	LEFT: 'left',
	NONE: 'none',
	TOP: 'top',
};
